/* ==========================================================================
   Bro Glo Bundle Builder — Shopify Section JavaScript
   External asset: bro-glo-bundle-builder.js
   ========================================================================== */

(function () {
  'use strict';

  document.querySelectorAll('.bro-bundle').forEach(initBundleBuilder);

  function initBundleBuilder(section) {
    /* ── Config from data attributes ── */
    const cfg = {
      sectionId: section.dataset.sectionId,
      tier2: parseInt(section.dataset.tier2Discount) || 10,
      tier3: parseInt(section.dataset.tier3Discount) || 15,
      tier4: parseInt(section.dataset.tier4Discount) || 20,
      minItems: parseInt(section.dataset.minItems) || 2,
      maxSlots: parseInt(section.dataset.maxSlots) || 6,
      freeShipping: (parseInt(section.dataset.freeShipping) || 75) * 100,
      showShipping: section.dataset.showShipping === 'true',
      showUrgency: section.dataset.showUrgency === 'true',
      showSocial: section.dataset.showSocial === 'true',
      showQuickBundle: section.dataset.showQuickBundle === 'true',
      quickBundleIds: (section.dataset.quickBundleIds || '').split(',').filter(Boolean),
      ctaActiveText: section.dataset.ctaActiveText || 'Add Bundle to Cart • [total]',
      ctaDisabledText: section.dataset.ctaDisabledText || 'Select at Least [min] Items',
      bundleKey: '_bundle_' + (section.dataset.collectionHandle || 'custom'),
      cartAction: section.dataset.cartAction || 'drawer',
      cartDrawerSelector: section.dataset.cartDrawerSelector || 'auto',
      showCalloutSuggestion: section.dataset.showCalloutSuggestion === 'true',
      showNudgeBar: section.dataset.showNudgeBar === 'true',
      showHeaderSavings: section.dataset.showHeaderSavings === 'true',
      showPriceComparison: section.dataset.showPriceComparison === 'true',
      itemsLabel: section.dataset.itemsLabel || 'YOUR BRO GLO BUNDLE',
    };

    const TIERS = [
      { min: 2, discount: cfg.tier2 },
      { min: 3, discount: cfg.tier3 },
      { min: 4, discount: cfg.tier4 },
    ].filter(t => t.discount > 0);

    /* ── Product data (from JSON script tags) ── */
    const productCards = section.querySelectorAll('.bb-card');
    const allProducts = [];
    productCards.forEach(card => {
      const jsonEl = card.querySelector('[data-product-variants]');
      let variants = [];
      try { variants = jsonEl ? JSON.parse(jsonEl.textContent) : []; }
      catch (e) { console.error('BB: variant parse error', e); }
      allProducts.push({
        id: card.dataset.productId,
        title: card.dataset.productTitle,
        handle: card.dataset.productHandle,
        description: card.dataset.productDesc || '',
        badge: card.dataset.productBadge || '',
        variants,
        card,
      });
    });

    /* ── State ── */
    let bundleItems = []; // { uniqueId, productId, variantId, title, variantTitle, price, image, thumb, handle, qty }
    let sheetOpen = false;
    let animSavings = 0;
    let animTotal = 0;
    let animHeaderSavings = 0;
    let modalProduct = null;
    let lastFocusBeforeModal = null;
    let previousTierIndex = -1;
    let previousDiscPct = 0;
    let toastTimeout = null;

    /* ── DOM refs ── */
    const els = {
      announce: section.querySelector('[data-bb-announce]'),
      // Toast
      toast: section.querySelector('[data-bb-toast]'),
      toastMsg: section.querySelector('[data-bb-toast-msg]'),
      // Conversion boosters
      nudge: section.querySelector('[data-bb-nudge]'),
      nudgeText: section.querySelector('[data-bb-nudge-text]'),
      headerSavings: section.querySelector('[data-bb-header-savings]'),
      headerSavingsText: section.querySelector('[data-bb-header-savings-text]'),
      // Desktop
      tiersDesktop: section.querySelector('[data-bb-tiers-desktop]'),
      slotsDesktop: section.querySelector('[data-bb-slots-desktop]'),
      progressDesktop: section.querySelector('[data-bb-progress-desktop]'),
      panelBody: section.querySelector('[data-bb-panel-body]'),
      panelCta: section.querySelector('[data-bb-panel-cta]'),
      // Mobile
      drawer: section.querySelector('[data-bb-drawer]'),
      slotsMobile: section.querySelector('[data-bb-slots-mobile]'),
      progressMobile: section.querySelector('[data-bb-progress-mobile]'),
      drawerSavings: section.querySelector('[data-bb-drawer-savings]'),
      drawerTotal: section.querySelector('[data-bb-drawer-total]'),
      ctaMobile: section.querySelector('[data-bb-cta-mobile]'),
      // Bottom sheet
      sheetBackdrop: section.querySelector('[data-bb-sheet-backdrop]'),
      sheet: section.querySelector('[data-bb-sheet]'),
      sheetBody: section.querySelector('[data-bb-sheet-body]'),
      // Modal
      modalOverlay: section.querySelector('[data-bb-modal-overlay]'),
      modal: section.querySelector('[data-bb-modal]'),
      modalImage: section.querySelector('[data-bb-modal-image]'),
      modalTitle: section.querySelector('[data-bb-modal-title]'),
      modalPrice: section.querySelector('[data-bb-modal-price]'),
      modalDesc: section.querySelector('[data-bb-modal-desc]'),
      modalOptions: section.querySelector('[data-bb-modal-options]'),
      modalAdd: section.querySelector('[data-bb-modal-add]'),
      modalClose: section.querySelector('[data-bb-modal-close]'),
      // Success
      success: section.querySelector('[data-bb-success]'),
      successSub: section.querySelector('[data-bb-success-sub]'),
      // Grain targets
      grainEls: section.querySelectorAll('[data-bb-grain]'),
    };

    /* ── Helpers ── */
    const fmt = c => '$' + (c / 100).toFixed(2);
    const uid = () => Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    const getTotalQty = () => bundleItems.reduce((s, i) => s + i.qty, 0);
    const getSubtotal = () => bundleItems.reduce((s, i) => s + (i.price * i.qty), 0);

    function getDiscount(totalQty) {
      for (let i = TIERS.length - 1; i >= 0; i--) {
        if (totalQty >= TIERS[i].min) return TIERS[i].discount;
      }
      return 0;
    }
    function getNextTier(totalQty) {
      return TIERS.find(t => t.min > totalQty) || null;
    }
    function announce(msg) {
      if (!els.announce) return;
      els.announce.textContent = '';
      requestAnimationFrame(() => { els.announce.textContent = msg; });
    }
    function animateValue(from, to, dur, cb) {
      const start = performance.now();
      const diff = to - from;
      if (diff === 0) { cb(to); return; }
      function tick(now) {
        const t = Math.min((now - start) / dur, 1);
        cb(Math.round(from + diff * (1 - Math.pow(1 - t, 3))));
        if (t < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    /* ── Current tier index (-1 = no tier) ── */
    function getCurrentTierIndex(totalQty) {
      for (let i = TIERS.length - 1; i >= 0; i--) {
        if (totalQty >= TIERS[i].min) return i;
      }
      return -1;
    }

    /* ── Tier Unlocked Toast ── */
    function showTierToast(discount, isMax) {
      if (!els.toast) return;
      if (toastTimeout) clearTimeout(toastTimeout);

      /* Toggle max variant class */
      els.toast.classList.toggle('bb-toast--max', !!isMax);

      /* Update message */
      if (els.toastMsg) {
        els.toastMsg.textContent = isMax
          ? "You're saving " + discount + '% - our biggest discount'
          : "You're now saving " + discount + '%';
      }

      /* Update title */
      var titleEl = els.toast.querySelector('.bb-toast__title');
      if (titleEl) {
        titleEl.textContent = isMax ? 'MAX SAVINGS UNLOCKED!' : 'Tier Unlocked!';
      }

      els.toast.classList.remove('bb-toast--active');
      void els.toast.offsetWidth;
      els.toast.classList.add('bb-toast--active');
      toastTimeout = setTimeout(function() {
        els.toast.classList.remove('bb-toast--active');
      }, isMax ? 4500 : 3500);

      /* CTA shimmer on max tier */
      if (isMax) {
        setTimeout(function() {
          section.querySelectorAll('.bb-cta--active').forEach(function(btn) {
            btn.classList.remove('bb-cta--shimmer');
            void btn.offsetWidth;
            btn.classList.add('bb-cta--shimmer');
            btn.addEventListener('animationend', function handler() {
              btn.classList.remove('bb-cta--shimmer');
              btn.removeEventListener('animationend', handler);
            });
          });
          if (els.ctaMobile && !els.ctaMobile.disabled) {
            els.ctaMobile.classList.remove('bb-cta--shimmer');
            void els.ctaMobile.offsetWidth;
            els.ctaMobile.classList.add('bb-cta--shimmer');
            els.ctaMobile.addEventListener('animationend', function handler() {
              els.ctaMobile.classList.remove('bb-cta--shimmer');
              els.ctaMobile.removeEventListener('animationend', handler);
            });
          }
        }, 400);
      }
    }

    /* ── Desktop Tier Indicator Row ── */
    function renderTiers(container, totalQty, justUnlockedIndex) {
      if (!container) return;
      container.innerHTML = '';
      if (!TIERS.length) return;
      var currentTierIdx = getCurrentTierIndex(totalQty);
      var nextTierIdx = TIERS.findIndex(function(t) { return t.min > totalQty; });

      TIERS.forEach(function(tier, i) {
        var pill = document.createElement('div');
        pill.setAttribute('role', 'listitem');
        var state = '';
        var iconHtml = '';

        if (totalQty >= tier.min) {
          /* Unlocked */
          state = 'bb-tier--unlocked';
          iconHtml = '<span class="bb-tier__icon"><svg aria-hidden="true" focusable="false" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg></span>';
          pill.setAttribute('aria-label', tier.min + ' items: ' + tier.discount + '% off - unlocked');
        } else if (i === nextTierIdx) {
          /* Next tier - golden glo highlight with lock */
          state = 'bb-tier--next';
          iconHtml = '<span class="bb-tier__icon" aria-hidden="true"><svg aria-hidden="true" focusable="false" width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg></span>';
          pill.setAttribute('aria-label', tier.min + ' items: ' + tier.discount + '% off - add ' + (tier.min - totalQty) + ' more to unlock');
        } else {
          /* Future locked tier */
          state = 'bb-tier--locked';
          iconHtml = '<span class="bb-tier__icon" aria-hidden="true"><svg aria-hidden="true" focusable="false" width="10" height="10" viewBox="0 0 24 24" fill="currentColor"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/></svg></span>';
          pill.setAttribute('aria-label', tier.min + ' items: ' + tier.discount + '% off - locked');
        }

        /* Pulse if this tier was just unlocked */
        if (justUnlockedIndex === i) state += ' bb-tier--pulse';

        pill.className = 'bb-tier ' + state;

        var labelText = totalQty >= tier.min ? 'UNLOCKED' : (i === nextTierIdx ? ('Add ' + (tier.min - totalQty) + ' more') : 'LOCKED');

        pill.innerHTML =
          iconHtml +
          '<span class="bb-tier__count">' + tier.min + '</span>' +
          '<span class="bb-tier__discount">' + tier.discount + '% OFF</span>' +
          '<span class="bb-tier__label">' + labelText + '</span>';

        container.appendChild(pill);
      });

      /* Clean up pulse class after animation */
      if (justUnlockedIndex >= 0) {
        var pulseEl = container.querySelector('.bb-tier--pulse');
        if (pulseEl) {
          pulseEl.addEventListener('animationend', function() {
            pulseEl.classList.remove('bb-tier--pulse');
          }, { once: true });
        }
      }
    }

    /* ── Live Strikethrough Pricing on Product Cards ── */
    function updateCardPrices(discPct, animate) {
      productCards.forEach(function(card) {
        var variant = getCardVariant(card);
        if (!variant) return;
        var priceEl = card.querySelector('[data-bb-product-price]');
        if (!priceEl) return;

        var originalPrice = variant.price;

        if (discPct > 0) {
          var salePrice = Math.round(originalPrice * (1 - discPct / 100));
          var prevAnimated = parseInt(priceEl.dataset.bbAnimatedPrice) || originalPrice;

          priceEl.innerHTML =
            '<span class="bb-card__price-original">' + fmt(originalPrice) + '</span>' +
            '<span class="bb-card__price-sale" data-bb-sale-price>' + fmt(prevAnimated) + '</span>';

          var saleEl = priceEl.querySelector('[data-bb-sale-price]');

          if (animate && prevAnimated !== salePrice && saleEl) {
            /* Animated counter tick */
            animateValue(prevAnimated, salePrice, 400, function(v) {
              saleEl.textContent = fmt(v);
            });
            /* Bounce tick */
            saleEl.classList.remove('bb-card__price-sale--tick');
            void saleEl.offsetWidth;
            saleEl.classList.add('bb-card__price-sale--tick');
          } else if (saleEl) {
            saleEl.textContent = fmt(salePrice);
          }

          priceEl.dataset.bbAnimatedPrice = salePrice;
        } else {
          /* No discount - show regular price */
          priceEl.innerHTML = fmt(originalPrice);
          priceEl.dataset.bbAnimatedPrice = originalPrice;
        }
      });
    }

    /* ── Sticky Nudge Bar (Desktop - #1) ── */
    function updateNudgeBar(totalQty, discPct, discAmt) {
      if (!cfg.showNudgeBar || !els.nudge || !els.nudgeText) return;

      if (totalQty === 0) {
        els.nudge.style.display = 'none';
        return;
      }

      els.nudge.style.display = '';
      var nextTier = getNextTier(totalQty);
      var isMax = !nextTier && discPct > 0;

      els.nudge.classList.toggle('bb-nudge--max', isMax);

      if (isMax) {
        els.nudgeText.innerHTML = '🎉 <strong>MAX SAVINGS UNLOCKED</strong> - ' + discPct + '% OFF everything in your bundle';
      } else if (discPct > 0 && nextTier) {
        var need = nextTier.min - totalQty;
        els.nudgeText.innerHTML = 'Saving <span class="bb-hl">' + fmt(discAmt) + '</span> so far - add ' + need + ' more for <span class="bb-nudge-golden">' + nextTier.discount + '% off!</span>';
      } else if (totalQty > 0 && totalQty < cfg.minItems) {
        var need2 = cfg.minItems - totalQty;
        els.nudgeText.innerHTML = 'Add <strong>' + need2 + ' more item' + (need2 > 1 ? 's' : '') + '</strong> to unlock <span class="bb-hl">' + TIERS[0].discount + '% off!</span>';
      } else {
        els.nudge.style.display = 'none';
      }
    }

    /* ── Header Savings Pill (#3) ── */
    function updateHeaderSavings(discAmt) {
      if (!cfg.showHeaderSavings || !els.headerSavings) return;

      if (discAmt <= 0) {
        els.headerSavings.style.display = 'none';
        return;
      }

      els.headerSavings.style.display = '';
      /* Animated counter */
      animateValue(animHeaderSavings, discAmt, 400, function(v) {
        animHeaderSavings = v;
        if (els.headerSavingsText) {
          els.headerSavingsText.textContent = "You're saving " + fmt(v);
        }
      });
    }

    /* ── Price Comparison HTML (#5) ── */
    function getComparisonHTML(subtotal, total, discPct) {
      if (!cfg.showPriceComparison || discPct <= 0 || subtotal <= 0) return '';
      return '<div class="bb-comparison">' +
        '<span class="bb-comparison__original">Separately: ' + fmt(subtotal) + '</span>' +
        '<span class="bb-comparison__sep">|</span>' +
        '<span class="bb-comparison__bundle">Bundle: ' + fmt(total) + '</span>' +
        '</div>';
    }

    function getMobileComparisonHTML(subtotal, total, discPct) {
      if (!cfg.showPriceComparison || discPct <= 0 || subtotal <= 0) return '';
      return '<div class="bb-drawer__comparison">' +
        '<span class="bb-comparison__original">Separately: ' + fmt(subtotal) + '</span>' +
        '<span class="bb-comparison__sep"> | </span>' +
        '<span class="bb-comparison__bundle">Bundle: ' + fmt(total) + '</span>' +
        '</div>';
    }

    /* ── Grain texture ── */
    function generateGrain() {
      const c = document.createElement('canvas');
      c.width = 256; c.height = 256;
      const ctx = c.getContext('2d');
      const img = ctx.createImageData(256, 256);
      for (let i = 0; i < img.data.length; i += 4) {
        const v = Math.random() * 255;
        img.data[i] = img.data[i + 1] = img.data[i + 2] = v;
        img.data[i + 3] = 18;
      }
      ctx.putImageData(img, 0, 0);
      const url = c.toDataURL();
      els.grainEls.forEach(el => { el.style.backgroundImage = `url(${url})`; });
    }

    /* ── Get selected variant from card ── */
    function getCardVariant(card) {
      const product = allProducts.find(p => p.card === card);
      if (!product || !product.variants.length) return null;
      const selects = card.querySelectorAll('.bb-card__select');
      if (!selects.length) return product.variants[0];
      const options = {};
      selects.forEach(s => { options['option' + s.dataset.optionPosition] = s.value; });
      return product.variants.find(v =>
        Object.entries(options).every(([k, val]) => v[k] === val)
      ) || product.variants[0];
    }

    /* ── Get variant image (prefer featured_image assigned in Shopify admin) ── */
    function getVariantImage(variant) {
      if (variant.featured_image) {
        return { full: variant.featured_image, thumb: variant.thumb || variant.featured_image };
      }
      if (variant.gang_media && variant.gang_media.length > 0) {
        return { full: variant.gang_media[0].src, thumb: variant.gang_media[0].thumb || variant.gang_media[0].src };
      }
      return { full: null, thumb: null };
    }

    /* ── Find cheapest unadded product ── */
    function getCheapestUnadded() {
      const addedIds = bundleItems.map(i => i.productId);
      const avail = allProducts.filter(p => !addedIds.includes(p.id));
      if (!avail.length) return null;
      return avail.reduce((min, p) => {
        const price = p.variants[0]?.price || Infinity;
        const minPrice = min.variants[0]?.price || Infinity;
        return price < minPrice ? p : min;
      }, avail[0]);
    }

    /* ══════════════════════════════════════════════
       RENDERING
       ══════════════════════════════════════════════ */

    /* ── Slots ── */
    function renderSlots(container, compact) {
      if (!container) return;
      container.innerHTML = '';
      const cols = compact ? Math.min(cfg.maxSlots, 6) : cfg.maxSlots;
      container.style.gridTemplateColumns = `repeat(${cols}, minmax(0, 1fr))`;

      /* Expand items by qty so each unit fills its own slot */
      const expanded = [];
      bundleItems.forEach(function(item) {
        for (var q = 0; q < item.qty; q++) {
          expanded.push({ item: item });
        }
      });
      var totalFilled = expanded.length;

      for (let i = 0; i < cfg.maxSlots; i++) {
        const entry = expanded[i] || null;
        const item = entry ? entry.item : null;
        const state = i < totalFilled ? 'filled' : i === totalFilled ? 'next' : 'empty';

        let tierLabel = null;
        for (let t = TIERS.length - 1; t >= 0; t--) {
          if (i + 1 === TIERS[t].min) { tierLabel = TIERS[t].discount + '% OFF'; break; }
        }

        const slot = document.createElement('div');
        slot.className = 'bb-slot bb-slot--' + state;
        slot.setAttribute('role', 'listitem');
        slot.setAttribute('aria-label', item
          ? 'Slot ' + (i + 1) + ': ' + item.title
          : 'Slot ' + (i + 1) + ': empty');

        let boxInner = '';
        if (item) {
          boxInner = item.thumb
            ? '<img src="' + item.thumb + '" alt="' + item.title + '" loading="lazy" width="100" height="100">'
            : '<span style="font-family:var(--bb-font-heading);font-size:8px;font-weight:700;color:rgba(255,255,255,0.7);letter-spacing:1px">BG</span>';
        } else {
          boxInner = '<svg aria-hidden="true" focusable="false" width="16" height="16" class="bb-slot__plus" viewBox="0 0 24 24" fill="none" stroke-width="2.5" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
        }

        let extras = '';
        /* Every filled slot gets its own X that removes one unit */
        if (item) extras += '<button class="bb-slot__remove" data-bb-slot-dec="' + item.uniqueId + '" aria-label="Remove one ' + item.title + '">&times;</button>';

        slot.innerHTML =
          '<div class="bb-slot__box"><div class="bb-slot__box-inner">' + boxInner + '</div>' + extras + '</div>' +
          (tierLabel ? '<span class="bb-slot__tier">' + tierLabel + '</span>' : '');

        container.appendChild(slot);
      }

      container.querySelectorAll('[data-bb-slot-dec]').forEach(btn => {
        btn.addEventListener('click', e => {
          e.stopPropagation();
          const id = btn.dataset.bbSlotDec;
          const item = bundleItems.find(i => i.uniqueId === id);
          if (item && item.qty > 1) {
            item.qty -= 1;
            queueUpdate();
            announce(item.title + ': ' + item.qty + '. ' + getTotalQty() + ' total.');
          } else {
            removeItem(id);
          }
        });
      });
    }

    /* ── Progress (with optional tier milestones) ── */
    function renderProgress(container, showMilestones, justUnlockedIndex) {
      if (!container) return;
      const totalQty = getTotalQty();
      const pct = Math.min((totalQty / cfg.maxSlots) * 100, 100);
      const isMax = totalQty >= cfg.maxSlots;

      var trackInner = '<div class="bb-progress__fill ' + (isMax ? 'bb-progress__fill--max' : '') + '" style="width:' + pct + '%"></div>';

      /* Milestone markers on the track */
      if (showMilestones && TIERS.length) {
        var currentTierIdx = getCurrentTierIndex(totalQty);
        var nextTierIdx = TIERS.findIndex(function(t) { return t.min > totalQty; });

        TIERS.forEach(function(tier, i) {
          var milePct = (tier.min / cfg.maxSlots) * 100;
          var state = '';
          if (totalQty >= tier.min) {
            state = 'bb-progress__milestone--reached';
            if (justUnlockedIndex === i) state += ' bb-progress__milestone--pulse';
          } else if (i === nextTierIdx) {
            state = 'bb-progress__milestone--next';
          }

          var checkSvg = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';

          trackInner += '<div class="bb-progress__milestone ' + state + '" style="left:' + milePct + '%">'
            + checkSvg
            + '<span class="bb-progress__milestone-label">' + tier.discount + '%</span>'
            + '</div>';
        });
      }

      container.innerHTML =
        '<div class="bb-progress__track">' + trackInner + '</div>' +
        '<div class="bb-progress__labels"><span>' + totalQty + ' of ' + cfg.maxSlots + ' items</span>' +
        (isMax ? '<span class="bb-progress__max-label">MAX SAVINGS!</span>' : '') + '</div>';
      container.setAttribute('role', 'progressbar');
      container.setAttribute('aria-valuenow', totalQty);
      container.setAttribute('aria-valuemax', cfg.maxSlots);

      /* Clean up pulse on milestones */
      if (showMilestones && justUnlockedIndex >= 0) {
        var pulseMs = container.querySelector('.bb-progress__milestone--pulse');
        if (pulseMs) {
          pulseMs.addEventListener('animationend', function() {
            pulseMs.classList.remove('bb-progress__milestone--pulse');
          }, { once: true });
        }
      }
    }

    /* ── Callout ── */
    function getCalloutHTML() {
      const totalQty = getTotalQty();
      const subtotal = getSubtotal();
      const disc = getDiscount(totalQty);
      const savings = Math.round(subtotal * (disc / 100));
      const nextTier = getNextTier(totalQty);
      const cheapest = cfg.showCalloutSuggestion ? getCheapestUnadded() : null;

      if (totalQty === 0)
        return '<div class="bb-callout bb-callout--info"><span>🏖️</span><span>Add <strong>' + cfg.minItems + ' items</strong> to start saving!</span></div>';
      if (totalQty < cfg.minItems) {
        const need = cfg.minItems - totalQty;
        const sug = cheapest
          ? 'Add the <strong>' + cheapest.title + '</strong> (' + fmt(cheapest.variants[0]?.price || 0) + ') and save <span class="bb-hl">' + TIERS[0].discount + '%!</span>'
          : 'Add <strong>' + need + ' more</strong> to unlock <span class="bb-hl">' + TIERS[0].discount + '% off!</span>';
        return '<div class="bb-callout bb-callout--info"><span>👆</span><span>' + sug + '</span></div>';
      }
      let extra = '';
      if (nextTier) {
        extra = cheapest
          ? ' — add the <strong>' + cheapest.title + '</strong> (' + fmt(cheapest.variants[0]?.price || 0) + ') for <span class="bb-hl">' + nextTier.discount + '% off!</span>'
          : ' — add 1 more for <span class="bb-hl">' + nextTier.discount + '% off!</span>';
      } else {
        extra = ' — maximum discount unlocked!';
      }
      return '<div class="bb-callout bb-callout--success" role="status"><span>🔥</span><span>Saving <span class="bb-hl">' + fmt(savings) + '</span>' + extra + '</span></div>';
    }

    /* ── Items list ── */
    function renderItemsList(container) {
      if (!container) return;
      container.innerHTML = '';
      if (!bundleItems.length) return;

      container.innerHTML =
        '<div class="bb-items-label">' + cfg.itemsLabel + '</div>' +
        '<div class="bb-items-list" role="list"></div>';

      const list = container.querySelector('.bb-items-list');
      bundleItems.forEach(item => {
        const row = document.createElement('div');
        row.className = 'bb-item';
        row.setAttribute('role', 'listitem');
        const thumbHtml = item.thumb
          ? '<img src="' + item.thumb + '" alt="' + item.title + '" loading="lazy" width="40" height="40">'
          : '';
        row.innerHTML =
          '<div class="bb-item__thumb" style="' + (item.thumb ? '' : 'background:#ddd;display:flex;align-items:center;justify-content:center') + '">' + thumbHtml + '</div>' +
          '<div class="bb-item__details"><div class="bb-item__title">' + item.title + (item.variantTitle && item.variantTitle !== 'Default Title' ? ' — ' + item.variantTitle : '') + '</div>' +
          '<div class="bb-item__stepper">' +
          '<button class="bb-item__step-btn" data-bb-step-down="' + item.uniqueId + '" aria-label="Decrease ' + item.title + ' quantity"' + (item.qty <= 1 ? ' disabled' : '') + '>−</button>' +
          '<span class="bb-item__qty-val" aria-live="polite">' + item.qty + '</span>' +
          '<button class="bb-item__step-btn" data-bb-step-up="' + item.uniqueId + '" aria-label="Increase ' + item.title + ' quantity">+</button></div></div>' +
          '<div class="bb-item__right"><span class="bb-item__price">' + fmt(item.price * item.qty) + '</span>' +
          '<button class="bb-item__remove-btn" data-bb-item-remove="' + item.uniqueId + '" aria-label="Remove ' + item.title + '">Remove</button></div>';
        list.appendChild(row);
      });

      container.querySelectorAll('[data-bb-step-up]').forEach(b => b.addEventListener('click', () => changeQty(b.dataset.bbStepUp, 1)));
      container.querySelectorAll('[data-bb-step-down]').forEach(b => b.addEventListener('click', () => changeQty(b.dataset.bbStepDown, -1)));
      container.querySelectorAll('[data-bb-item-remove]').forEach(b => {
        b.addEventListener('click', () => {
          removeItem(b.dataset.bbItemRemove);
          const firstAdd = section.querySelector('.bb-card__add-btn');
          if (firstAdd) firstAdd.focus();
        });
      });
    }

    /* ── Shipping bar ── */
    function getShippingHTML(total) {
      if (!cfg.showShipping || total <= 0) return '';
      if (total >= cfg.freeShipping)
        return '<div class="bb-shipping-bar"><div class="bb-shipping-bar__text">✅ You\'ve unlocked <span class="bb-hl">FREE shipping!</span></div><div class="bb-shipping-bar__track"><div class="bb-shipping-bar__fill" style="width:100%"></div></div></div>';
      const rem = cfg.freeShipping - total;
      const pct = Math.min((total / cfg.freeShipping) * 100, 100);
      return '<div class="bb-shipping-bar"><div class="bb-shipping-bar__text">🚚 <span class="bb-hl">' + fmt(rem) + '</span> away from free shipping!</div><div class="bb-shipping-bar__track"><div class="bb-shipping-bar__fill" style="width:' + pct + '%"></div></div></div>';
    }

    /* ── Totals ── */
    function getTotalsHTML(subtotal, discPct, discAmt, total) {
      if (!bundleItems.length) return '';
      let h = '<div class="bb-totals">';
      h += '<div class="bb-totals__row"><span>Subtotal</span><span>' + fmt(subtotal) + '</span></div>';
      if (discPct > 0)
        h += '<div class="bb-totals__row bb-totals__row--discount"><span>Bundle Savings (' + discPct + '%)</span><span>−<span class="bb-js-savings">' + fmt(discAmt) + '</span></span></div>';
      h += '<div class="bb-totals__row bb-totals__row--total"><span>Total</span><span>';
      if (discPct > 0) h += '<span class="bb-totals__struck">' + fmt(subtotal) + '</span>';
      h += '<span class="bb-js-total">' + fmt(total) + '</span></span></div></div>';
      return h;
    }

    /* ── CTA ── */
    function updateCTA(btn, savingsEl, totalQty, total, discAmt) {
      if (!btn) return;
      const active = totalQty >= cfg.minItems;
      btn.disabled = !active;
      btn.className = btn.className.replace(/\s*bb-cta--active/g, '') + (active ? ' bb-cta--active' : '');
      if (active) {
        btn.textContent = cfg.ctaActiveText.replace('[total]', fmt(total));
        btn.setAttribute('aria-label', 'Add bundle to cart for ' + fmt(total));
      } else if (totalQty === 0) {
        btn.textContent = cfg.ctaDisabledText.replace('[min]', cfg.minItems);
        btn.setAttribute('aria-label', 'Add at least ' + cfg.minItems + ' items to continue');
      } else {
        const need = cfg.minItems - totalQty;
        btn.textContent = 'Add ' + need + ' More Item' + (need > 1 ? 's' : '');
        btn.setAttribute('aria-label', 'Add ' + need + ' more item' + (need > 1 ? 's' : '') + ' to continue');
      }
      if (savingsEl) savingsEl.textContent = active && discAmt > 0 ? 'You save ' + fmt(discAmt) + '! 🎉' : '';
    }

    /* ══════════════════════════════════════════════
       FULL UI UPDATE (debounced)
       ══════════════════════════════════════════════ */
    let queued = false;
    function queueUpdate() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; renderUI(); });
    }

    function renderUI() {
      const totalQty = getTotalQty();
      const subtotal = getSubtotal();
      const discPct = getDiscount(totalQty);
      const discAmt = Math.round(subtotal * (discPct / 100));
      const total = subtotal - discAmt;

      /* ── Tier change detection ── */
      const currentTierIdx = getCurrentTierIndex(totalQty);
      let justUnlockedIndex = -1;
      if (currentTierIdx > previousTierIndex && previousTierIndex !== -1 || (currentTierIdx === 0 && previousTierIndex === -1 && totalQty >= TIERS[0].min && bundleItems.length > 0)) {
        justUnlockedIndex = currentTierIdx;
        const isMax = currentTierIdx === TIERS.length - 1;
        showTierToast(TIERS[currentTierIdx].discount, isMax);
      }
      previousTierIndex = currentTierIdx;

      /* ── Live card pricing ── */
      const shouldAnimatePrices = discPct !== previousDiscPct;
      updateCardPrices(discPct, shouldAnimatePrices);
      previousDiscPct = discPct;

      /* Desktop panel */
      if (els.panelBody) {
        const calloutHtml = getCalloutHTML();
        const itemsId = 'bb-items-' + cfg.sectionId;
        const shippingHtml = getShippingHTML(total);
        const totalsHtml = getTotalsHTML(subtotal, discPct, discAmt, total);

        let html = '';
        html += calloutHtml;
        html += '<div id="' + itemsId + '"></div>';
        html += shippingHtml;
        html += totalsHtml;
        els.panelBody.innerHTML = html;

        renderItemsList(els.panelBody.querySelector('#' + itemsId));
      }

      /* Desktop pinned CTA footer */
      if (els.panelCta) {
        var comparisonHtml = getComparisonHTML(subtotal, total, discPct);
        els.panelCta.innerHTML = '<div class="bb-cta-wrap"><button class="bb-cta" data-bb-cta-desktop>Loading</button><div class="bb-cta-savings" data-bb-cta-savings-desktop></div>' + comparisonHtml + '</div>';
        const ctaD = els.panelCta.querySelector('[data-bb-cta-desktop]');
        const ctaSavD = els.panelCta.querySelector('[data-bb-cta-savings-desktop]');
        updateCTA(ctaD, ctaSavD, totalQty, total, discAmt);
        if (ctaD) ctaD.addEventListener('click', handleAddToCart);
      }

      /* Desktop tier indicator row */
      renderTiers(els.tiersDesktop, totalQty, justUnlockedIndex);

      renderSlots(els.slotsDesktop, false);
      renderProgress(els.progressDesktop, false, -1);

      /* Desktop nudge bar */
      updateNudgeBar(totalQty, discPct, discAmt);

      /* Header savings pill */
      updateHeaderSavings(discAmt);

      /* Mobile drawer */
      renderSlots(els.slotsMobile, true);
      renderProgress(els.progressMobile, true, justUnlockedIndex);
      if (els.drawerSavings) els.drawerSavings.textContent = discPct > 0 ? '−' + fmt(discAmt) : '';
      if (els.drawerTotal) els.drawerTotal.textContent = fmt(total);

      /* Mobile bottom sheet content */
      if (els.sheetBody) {
        let sheetHtml = getCalloutHTML();
        sheetHtml += '<div data-bb-sheet-items></div>';
        sheetHtml += getShippingHTML(total);
        sheetHtml += getTotalsHTML(subtotal, discPct, discAmt, total);
        els.sheetBody.innerHTML = sheetHtml;
        renderItemsList(els.sheetBody.querySelector('[data-bb-sheet-items]'));
      }

      updateCTA(els.ctaMobile, null, totalQty, total, discAmt);

      /* Mobile comparison below CTA */
      var mobileCompWrap = section.querySelector('.bb-drawer__cta-wrap');
      if (mobileCompWrap) {
        var existingComp = mobileCompWrap.querySelector('.bb-drawer__comparison');
        if (existingComp) existingComp.remove();
        var mobileCompHtml = getMobileComparisonHTML(subtotal, total, discPct);
        if (mobileCompHtml) mobileCompWrap.insertAdjacentHTML('beforeend', mobileCompHtml);
      }

      /* Animate values */
      animateValue(animSavings, discAmt, 350, v => {
        animSavings = v;
        section.querySelectorAll('.bb-js-savings').forEach(el => { el.textContent = fmt(v); });
      });
      animateValue(animTotal, total, 350, v => {
        animTotal = v;
        section.querySelectorAll('.bb-js-total').forEach(el => { el.textContent = fmt(v); });
        if (totalQty >= cfg.minItems) {
          const ctaText = cfg.ctaActiveText.replace('[total]', fmt(v));
          section.querySelectorAll('[data-bb-cta-desktop]').forEach(b => { b.textContent = ctaText; });
          if (els.ctaMobile && !els.ctaMobile.disabled) els.ctaMobile.textContent = ctaText;
        }
      });
    }

    /* ══════════════════════════════════════════════
       ACTIONS
       ══════════════════════════════════════════════ */
    function addItem(card) {
      const product = allProducts.find(p => p.card === card);
      if (!product) return;

      const variant = getCardVariant(card);
      if (!variant) { console.error('BB: no variant found'); return; }

      const images = getVariantImage(variant);

      /* Already in bundle? Increment qty */
      const existing = bundleItems.find(i => i.variantId === variant.id);
      if (existing) {
        if (getTotalQty() >= cfg.maxSlots) {
          announce('Bundle is full. Maximum of ' + cfg.maxSlots + ' items.');
          return;
        }
        existing.qty += 1;
        queueUpdate();
        announce(product.title + ' qty ' + existing.qty + '. ' + getTotalQty() + ' total.');
        return;
      }

      /* Max total check */
      if (getTotalQty() >= cfg.maxSlots) {
        announce('Bundle is full. Maximum of ' + cfg.maxSlots + ' items.');
        return;
      }

      bundleItems.push({
        uniqueId: uid(),
        productId: product.id,
        variantId: variant.id,
        title: product.title,
        variantTitle: variant.title,
        price: variant.price,
        image: images.full,
        thumb: images.thumb,
        handle: product.handle,
        qty: 1,
      });

      queueUpdate();
      const tq = getTotalQty(), d = getDiscount(tq);
      announce(product.title + ' added. ' + tq + ' items.' + (d > 0 ? ' ' + d + '% discount.' : ''));
    }

    function addItemById(productId) {
      const product = allProducts.find(p => p.id === productId);
      if (product) addItem(product.card);
    }

    function removeItem(uniqueId) {
      const item = bundleItems.find(i => i.uniqueId === uniqueId);
      bundleItems = bundleItems.filter(i => i.uniqueId !== uniqueId);
      queueUpdate();
      if (item) announce(item.title + ' removed. ' + getTotalQty() + ' remaining.');
    }

    function changeQty(uniqueId, delta) {
      const item = bundleItems.find(i => i.uniqueId === uniqueId);
      if (!item) return;
      if (delta > 0 && getTotalQty() >= cfg.maxSlots) {
        announce('Bundle is full. Maximum of ' + cfg.maxSlots + ' items.');
        return;
      }
      item.qty = Math.max(1, item.qty + delta);
      queueUpdate();
      announce(item.title + ': ' + item.qty + '. ' + getTotalQty() + ' total.');
    }

    /* ── Quick bundle ── */
    function addQuickBundle() {
      bundleItems = [];
      cfg.quickBundleIds.forEach(id => {
        const product = allProducts.find(p => p.id === id);
        if (!product) return;
        const variant = product.variants[0];
        if (!variant) return;
        const images = getVariantImage(variant);
        bundleItems.push({
          uniqueId: uid(),
          productId: product.id,
          variantId: variant.id,
          title: product.title,
          variantTitle: variant.title,
          price: variant.price,
          image: images.full,
          thumb: images.thumb,
          handle: product.handle,
          qty: 1,
        });
      });
      queueUpdate();
      announce('Popular bundle added! ' + getTotalQty() + ' items. ' + getDiscount(getTotalQty()) + '% discount.');
    }

    /* ── Add to cart ── */
    async function handleAddToCart() {
      if (getTotalQty() < cfg.minItems) return;

      const discPct = getDiscount(getTotalQty());
      const items = bundleItems.map(item => ({
        id: item.variantId,
        quantity: item.qty,
        properties: {
          [cfg.bundleKey]: 'true',
          '_bundle_discount': 'true',
        }
      }));

      const btn = section.querySelector('.bb-cta--active');
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      try {
        const routesRoot = window.Shopify?.routes?.root || '/';
        const res = await fetch(routesRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!res.ok) throw new Error('Cart add failed: ' + res.status);

        announce('Bundle added to cart!');
        bundleItems = [];
        queueUpdate();
        openCartDrawer();

      } catch (err) {
        console.error('BB cart error:', err);
        if (btn) { btn.textContent = 'Error — Try Again'; btn.disabled = false; }
        announce('Error adding bundle. Please try again.');
      }
    }

    /* ── Cart drawer opening (all fallback methods) ── */
    function openCartDrawer() {
      if (cfg.cartAction === 'redirect') { window.location.href = '/cart'; return; }

      /* Custom selector */
      if (cfg.cartDrawerSelector && cfg.cartDrawerSelector !== 'auto') {
        const trigger = document.querySelector(cfg.cartDrawerSelector);
        if (trigger) { trigger.click(); return; }
      }

      /* BWCart (Bro Glo theme) */
      if (typeof window.BWCart !== 'undefined') {
        if (typeof window.BWCart.refresh === 'function') { window.BWCart.refresh(); }
        if (typeof window.BWCart.open === 'function') { window.BWCart.open(); return; }
      }

      /* CartDrawer.open */
      if (typeof window.CartDrawer !== 'undefined' && typeof window.CartDrawer.open === 'function') {
        window.CartDrawer.open(); return;
      }

      /* MonsterCart */
      if (typeof window.monster_refresh === 'function') { window.monster_refresh(true); return; }
      if (typeof window.openCart === 'function') { window.openCart(); return; }
      if (typeof window.toggleCart === 'function') { window.toggleCart(); return; }

      /* Hash method */
      window.location.hash = 'cart';

      /* Event dispatch */
      fetch('/cart.js').then(r => r.json()).then(cart => {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { items: cart.items } }));
      });
    }

    /* ══════════════════════════════════════════════
       MODAL (Quick View)
       ══════════════════════════════════════════════ */
    function openModal(productId) {
      const product = allProducts.find(p => p.id === productId);
      if (!product || !els.modalOverlay) return;
      modalProduct = product;
      lastFocusBeforeModal = document.activeElement;

      const variant = product.variants[0];
      const images = variant ? getVariantImage(variant) : {};

      /* Image */
      if (els.modalImage) {
        if (images.full) {
          els.modalImage.innerHTML = '<img src="' + images.full + '" alt="' + product.title + '" loading="lazy">';
        } else {
          els.modalImage.innerHTML = '';
          els.modalImage.style.background = '#f5f0ea';
        }
      }

      if (els.modalTitle) els.modalTitle.textContent = product.title;
      if (els.modalPrice) {
        const varPrice = variant?.price || 0;
        const discPct = getDiscount(getTotalQty());
        if (discPct > 0) {
          const salePrice = Math.round(varPrice * (1 - discPct / 100));
          els.modalPrice.innerHTML =
            '<span style="text-decoration:line-through;color:var(--bb-text-muted);font-size:0.85em;font-weight:500;margin-right:6px">' + fmt(varPrice) + '</span>' +
            '<span style="color:var(--bb-teal);font-weight:800">' + fmt(salePrice) + '</span>';
        } else {
          els.modalPrice.textContent = fmt(varPrice);
        }
      }
      if (els.modalDesc) els.modalDesc.textContent = product.description;

      /* Options */
      if (els.modalOptions) {
        if (product.variants.length > 1) {
          /* Build select dropdowns */
          // For prototype we keep it simple — full implementation mirrors card selects
          els.modalOptions.innerHTML = '';
        } else {
          els.modalOptions.innerHTML = '';
        }
      }

      els.modalOverlay.classList.add('bb-modal--active');
      if (els.modalClose) els.modalClose.focus();
      document.addEventListener('keydown', trapModalFocus);
    }

    function closeModal() {
      if (els.modalOverlay) els.modalOverlay.classList.remove('bb-modal--active');
      modalProduct = null;
      document.removeEventListener('keydown', trapModalFocus);
      if (lastFocusBeforeModal) lastFocusBeforeModal.focus();
    }

    function trapModalFocus(e) {
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key !== 'Tab' || !els.modal) return;
      const focusable = els.modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* ══════════════════════════════════════════════
       BOTTOM SHEET
       ══════════════════════════════════════════════ */
    function openSheet() {
      if (sheetOpen) return;
      sheetOpen = true;
      if (els.sheetBackdrop) els.sheetBackdrop.classList.add('bb-sheet-backdrop--active');
      if (els.sheet) {
        els.sheet.classList.add('bb-sheet--active');
        /* Force reflow then animate */
        void els.sheet.offsetHeight;
        els.sheet.style.transform = 'translateY(0)';
      }
      document.body.style.overflow = 'hidden';
    }
    function closeSheet() {
      if (!sheetOpen) return;
      sheetOpen = false;
      if (els.sheet) els.sheet.style.transform = '';
      if (els.sheetBackdrop) els.sheetBackdrop.classList.remove('bb-sheet-backdrop--active');
      if (els.sheet) els.sheet.classList.remove('bb-sheet--active');
      document.body.style.overflow = '';
    }

    /* ══════════════════════════════════════════════
       CAROUSEL (per product card)
       ══════════════════════════════════════════════ */
    function initCarouselForCard(card) {
      const carousel = card.querySelector('[data-bb-carousel]');
      const slides = carousel?.querySelectorAll('.bb-card__slide');
      const dots = card.querySelectorAll('.bb-card__dot');
      const prevBtn = card.querySelector('[data-bb-carousel-prev]');
      const nextBtn = card.querySelector('[data-bb-carousel-next]');
      if (!slides || slides.length <= 1) return;
      let cur = 0;
      const goTo = idx => {
        if (idx < 0) idx = slides.length - 1;
        if (idx >= slides.length) idx = 0;
        cur = idx;
        carousel.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
        dots.forEach((d, i) => d.classList.toggle('bb-card__dot--active', i === idx));
      };
      if (prevBtn) {
        const np = prevBtn.cloneNode(true);
        prevBtn.parentNode.replaceChild(np, prevBtn);
        np.addEventListener('click', () => goTo(cur - 1));
      }
      if (nextBtn) {
        const nn = nextBtn.cloneNode(true);
        nextBtn.parentNode.replaceChild(nn, nextBtn);
        nn.addEventListener('click', () => goTo(cur + 1));
      }
      dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));
      let scrollTimeout;
      carousel.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const newIdx = Math.round(carousel.scrollLeft / slides[0].offsetWidth);
          if (newIdx !== cur && newIdx >= 0 && newIdx < slides.length) {
            cur = newIdx;
            dots.forEach((d, i) => d.classList.toggle('bb-card__dot--active', i === cur));
          }
        }, 50);
      });
    }

    /* ── Variant selector change → update images + price ── */
    function initVariantSelectors() {
      section.querySelectorAll('.bb-card__select').forEach(select => {
        select.addEventListener('change', () => {
          const card = select.closest('.bb-card');
          if (!card) return;
          const variant = getCardVariant(card);
          if (!variant) return;

          // ── Update price ──
          const priceEl = card.querySelector('[data-bb-product-price]');
          if (priceEl) {
            const discPct = getDiscount(getTotalQty());
            if (discPct > 0) {
              const salePrice = Math.round(variant.price * (1 - discPct / 100));
              priceEl.innerHTML =
                '<span class="bb-card__price-original">' + fmt(variant.price) + '</span>' +
                '<span class="bb-card__price-sale">' + fmt(salePrice) + '</span>';
              priceEl.dataset.bbAnimatedPrice = salePrice;
            } else {
              priceEl.innerHTML = fmt(variant.price);
              priceEl.dataset.bbAnimatedPrice = variant.price;
            }
          }

          // ── Swap card carousel to variant image ──
          const images = getVariantImage(variant);
          if (images.full) {
            const carousel = card.querySelector('[data-bb-carousel]');
            const firstSlide = carousel?.querySelector('.bb-card__slide');
            const firstImg = firstSlide?.querySelector('img');
            if (firstImg) {
              firstImg.removeAttribute('srcset');
              firstImg.src = images.full;
            }
            // Reset carousel to first slide
            if (carousel) carousel.scrollTo({ left: 0, behavior: 'smooth' });
          }

          // ── If this product is already in the bundle, update its thumb + variantId in bundleItems ──
          const product = allProducts.find(p => p.card === card);
          if (product) {
            const existing = bundleItems.find(i => i.productId === product.id);
            if (existing) {
              const images = getVariantImage(variant);
              existing.variantId = variant.id;
              existing.variantTitle = variant.title;
              existing.price = variant.price;
              existing.image = images.full;
              existing.thumb = images.thumb;
              queueUpdate();
            }
          }
        });
      });
    }

    /* ══════════════════════════════════════════════
       EVENT DELEGATION
       ══════════════════════════════════════════════ */
    section.addEventListener('click', e => {
      /* Add to bundle */
      const addBtn = e.target.closest('[data-bb-add-to-bundle]');
      if (addBtn) {
        e.preventDefault();
        const card = addBtn.closest('.bb-card');
        if (card) {
          addItem(card);
          card.classList.remove('bb-card--flash');
          void card.offsetWidth;
          card.classList.add('bb-card--flash');
        }
        return;
      }

      /* Quick view button */
      const qvBtn = e.target.closest('[data-bb-quickview-btn]');
      if (qvBtn) { openModal(qvBtn.dataset.bbQuickviewBtn); return; }

      /* Quick bundle */
      const qbBtn = e.target.closest('[data-bb-quick-bundle]');
      if (qbBtn) { addQuickBundle(); return; }
    });

    /* ── Bottom sheet ── */
    section.querySelectorAll('[data-bb-sheet-open]').forEach(el => {
      el.addEventListener('click', openSheet);
      el.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openSheet(); } });
    });
    section.querySelectorAll('[data-bb-sheet-close]').forEach(el => el.addEventListener('click', closeSheet));
    if (els.sheetBackdrop) els.sheetBackdrop.addEventListener('click', closeSheet);
    if (els.sheet) {
      els.sheet.addEventListener('keydown', e => { if (e.key === 'Escape') closeSheet(); });
    }

    /* ── Mobile CTA ── */
    if (els.ctaMobile) els.ctaMobile.addEventListener('click', handleAddToCart);

    /* ── Modal ── */
    if (els.modalClose) els.modalClose.addEventListener('click', closeModal);
    if (els.modalOverlay) els.modalOverlay.addEventListener('click', e => { if (e.target === e.currentTarget) closeModal(); });
    if (els.modalAdd) {
      els.modalAdd.addEventListener('click', () => {
        if (modalProduct) addItem(modalProduct.card);
        closeModal();
      });
    }

    /* ── Success overlay ── */
    if (els.success) {
      els.success.addEventListener('click', () => {
        els.success.classList.remove('bb-success--active');
        bundleItems = [];
        queueUpdate();
      });
    }

    /* ══════════════════════════════════════════════
       SOCIAL PROOF COUNTER (localStorage-persisted)
       ══════════════════════════════════════════════ */
    function initSocialCounter() {
      const el = section.querySelector('[data-bb-social-counter]');
      if (!el) return;

      const prefix = el.dataset.socialPrefix || '🔥';
      const suffix = el.dataset.socialSuffix || 'bundles built this month';
      const baseMin = parseInt(el.dataset.socialBaseMin) || 1100;
      const baseMax = parseInt(el.dataset.socialBaseMax) || 1300;
      const incMin = parseInt(el.dataset.socialIncMin) || 1;
      const incMax = parseInt(el.dataset.socialIncMax) || 3;
      const interval = (parseInt(el.dataset.socialInterval) || 8) * 1000;
      const resetPeriod = el.dataset.socialReset || 'monthly';

      const storageKey = 'broglo_bb_social_' + cfg.sectionId;
      const now = Date.now();

      /* Determine current period key for reset logic */
      const d = new Date();
      let periodKey;
      if (resetPeriod === 'daily') {
        periodKey = d.toDateString();
      } else if (resetPeriod === 'weekly') {
        const jan1 = new Date(d.getFullYear(), 0, 1);
        const week = Math.ceil(((d - jan1) / 86400000 + jan1.getDay() + 1) / 7);
        periodKey = d.getFullYear() + '-W' + week;
      } else {
        periodKey = d.getFullYear() + '-' + (d.getMonth() + 1);
      }

      let count;
      try {
        const saved = JSON.parse(localStorage.getItem(storageKey));
        if (saved && typeof saved.count === 'number' && saved.period === periodKey) {
          /* Same period — catch up: ~1 tick per interval while away, capped at +50 */
          const elapsed = Math.floor((now - saved.ts) / interval);
          const catchUp = Math.min(elapsed, 50);
          let add = 0;
          for (let i = 0; i < catchUp; i++) add += incMin + Math.floor(Math.random() * (incMax - incMin + 1));
          count = saved.count + add;
        } else {
          count = baseMin + Math.floor(Math.random() * (baseMax - baseMin + 1));
        }
      } catch (e) {
        count = baseMin + Math.floor(Math.random() * (baseMax - baseMin + 1));
      }

      const render = () => { el.textContent = prefix + ' ' + count.toLocaleString() + ' ' + suffix; };
      const save = () => {
        try { localStorage.setItem(storageKey, JSON.stringify({ count, ts: Date.now(), period: periodKey })); } catch (e) {}
      };

      render();
      save();

      setInterval(() => {
        count += incMin + Math.floor(Math.random() * (incMax - incMin + 1));
        render();
        save();
      }, interval);
    }

    /* ══════════════════════════════════════════════
       INIT
       ══════════════════════════════════════════════ */
    generateGrain();
    productCards.forEach(initCarouselForCard);
    initVariantSelectors();
    initSocialCounter();
    queueUpdate();
  }
})();
